import { IAccess, IFolder, IMessage, ISelectedFolder } from '../interfaces';
import { isAllowed } from './access';
import { isDateGreaterThanToday } from './dateTime';
import { FolderTypeNames, MessageState, PermissionType } from '../enums';

export const IsMailReplyAllowed = (selDocumentList: IMessage[], access: IAccess, language: string): boolean => {
    if (!access) {
        return (
            selDocumentList.some((doc) => doc.messageState === MessageState.RECEIVED) &&
            selDocumentList[0].reply &&
            (selDocumentList[0].replyByDateTime
                ? isDateGreaterThanToday(selDocumentList[0].replyByDateTime, language)
                : true)
        );
    }

    return (
        isAllowed(access, PermissionType.SAVEDRAFT) &&
        selDocumentList.some((doc) => doc.messageState === MessageState.RECEIVED) &&
        selDocumentList[0].reply &&
        (selDocumentList[0].replyByDateTime
            ? isDateGreaterThanToday(selDocumentList[0].replyByDateTime, language)
            : true)
    );
};

export const IsMailDeleteAllowed = (
    multipleSelected: boolean,
    access: IAccess,
    folders: IFolder[],
    selectedFolder: ISelectedFolder
): boolean => {
    if (multipleSelected) {
        if (!access) {
            return true;
        }
        if (folders.findIndex((x) => x.folderType === FolderTypeNames.TRASH && x.id === selectedFolder.id) > -1) {
            return isAllowed(access, PermissionType.DELETEBIN);
        }
        return isAllowed(access, PermissionType.FOLDERDELETE);
    }
    return false;
};
